import styled from 'styled-components';
import { COLORS, FONTS } from '../../ui';

interface Props {
  show?: boolean;
}

export const TableResponsive = styled.div`
  width: 100%;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.BLACK};
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  font-weight: bold;
  font-size: 14px;
  background-color: ${COLORS.CONTENT_GRAY};
  margin-bottom: 16px;
  position: sticky;
  top: 50px;
  left: 0;
  right: 0;

  @media(min-width: 480px) {
    top: 0;
  }
`;

export const Body = styled.div`
  background-color: ${COLORS.CONTENT_GRAY};
  padding: 16px;
  margin-bottom: 16px;
`;

export const Main = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Wrapper = styled.div`
  max-height: 0;
  transition: all .4s ease;
  overflow: hidden;
  margin-bottom: 10px;

  ${(props: Props) => props.show && `
    max-height: 180px;
    transition: all .4s ease;
  `}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const More = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
`;
